import { saveSmsTemplateService, getAllSmsTemplateService,
    deleteSmsTemplateService,
    smsTemplateSearchService
 } from '../../../src/services/templateServices' 
import {
      START_LOADING,
      STOP_LOADING,
  } from "./actionTypes"

export const saveSmsTemplateAction = (formdata) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;    
    const response = await saveSmsTemplateService(formdata, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'SMS_TEMPLATE_SAVE_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'SMS_TEMPLATE_SAVE_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
  }
};

export const getSmsTemplateAction = (page, size = 5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");;    
      const response = await getAllSmsTemplateService(token, page, size);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_SMS_TEMPLATE_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_TEMPLATE_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  };

  export const deleteSmsTemplateAction = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");;    
      const response = await deleteSmsTemplateService(token, id);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'DELETE_SMS_TEMPLATE_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'DELETE_TEMPLATE_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  };
  
  export const searchSmsTemplateAction = (formData, page, size) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token || sessionStorage.getItem("token");;    
      const response = await smsTemplateSearchService(token, formData, page, size);
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SEARCH_SMS_TEMPLATE_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'SEARCH_SMS_TEMPLATE_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  };
  
  